import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable, throwError } from 'rxjs';
import { Message } from '../models/message.model';
import { SeverityType } from '../constants/severity-type.const';
import 'rxjs/add/operator/retry';
import { ContextDiscoveryEventBusService } from './context-discovery-event-bus.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient,
    private eventBusService: ContextDiscoveryEventBusService) {
  }

  private setHeaders(): HttpHeaders {
    const headersConfig = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };

    return new HttpHeaders(headersConfig);
  }

  private formatErrors(errorResponse: HttpErrorResponse) {
    if (errorResponse.status >= 500) {
      this.eventBusService.sendMessage(new Message('Something went wrong. Please retry later.', SeverityType.CRITICAL));
    } else if (errorResponse.status === 401) {
      this.eventBusService.sendMessage(new Message('Authorization failed. Please login again.', SeverityType.CRITICAL));
    }
    return throwError(errorResponse);
  }

  get(path: string, api_url: string, params: HttpParams = new HttpParams(), responseType?: 'json'): Observable<any> {
    return this.http.get(`${api_url}${path}`, { headers: this.setHeaders(), params, responseType })
      .catch((error) => this.formatErrors(error));
  }

  post(path: string, api_url: string, body: any = {}): Observable<any> {
    return this.http.post(`${api_url}${path}`, body, { headers: this.setHeaders() })
      .catch((error) => this.formatErrors(error));
  }

  put(path: string, api_url: string, body: any = {}): Observable<any> {
    return this.http.put(`${api_url}${path}`, body, { headers: this.setHeaders() })
      .catch((error) => this.formatErrors(error));
  }
}
